import MainHeading from '@/components/common/MainHeading'
import Layout from '@/components/layout/Layout'
import {
    Tabs,
    TabsContent,
    TabsList,
    TabsTrigger,
} from "@/components/ui/tabs";
import NestedTabs from "./NestedTabs";
import React from 'react'
import { ShieldCheck, Scale, FileSignature } from 'lucide-react'

const Setting: React.FC = () => {
    return (
        <Layout>
            <div className="space-y-6">
                <MainHeading title="Documents" isBackButtonVisible={true} />


                <div className="space-y-6">
                    <Tabs defaultValue="policy" className="w-full">
                        <TabsList className="bg-slate-100/80 flex py-5 flex-nowrap overflow-x-auto overflow-y-hidden h-fit gap-2 rounded-lg border border-slate-200/60 shadow-inner mb-6 scroll-bar-hidden items-center">
                            <TabsTrigger
                                value="policy"
                                className="rounded-lg py-3.5 px-3 data-[state=active]:bg-white data-[state=active]:shadow-md data-[state=active]:text-primary data-[state=active]:border-primary/20 border border-transparent flex-1 font-semibold transition-all flex items-center justify-center gap-2 text-slate-500 hover:text-slate-700 hover:bg-slate-200/50 data-[state=active]:hover:bg-white cursor-pointer"
                            >
                                <ShieldCheck className="w-4 h-4 text-muted-foreground group-data-[state=active]:text-primary group-hover:scale-110 transition-transform duration-300" />
                                <span>Policy</span>
                            </TabsTrigger>

                            <TabsTrigger
                                value="terms"
                                className="rounded-lg py-3.5 px-3 data-[state=active]:bg-white data-[state=active]:shadow-md data-[state=active]:text-primary data-[state=active]:border-primary/20 border border-transparent flex-1 font-semibold transition-all flex items-center justify-center gap-2 text-slate-500 hover:text-slate-700 hover:bg-slate-200/50 data-[state=active]:hover:bg-white cursor-pointer"
                            >
                                <Scale className="w-4 h-4 text-muted-foreground group-data-[state=active]:text-primary group-hover:scale-110 transition-transform duration-300" />
                                <span>Terms & Conditions</span>
                            </TabsTrigger>

                            <TabsTrigger
                                value="letter"
                                className="rounded-lg py-3.5 px-3 data-[state=active]:bg-white data-[state=active]:shadow-md data-[state=active]:text-primary data-[state=active]:border-primary/20 border border-transparent flex-1 font-semibold transition-all flex items-center justify-center gap-2 text-slate-500 hover:text-slate-700 hover:bg-slate-200/50 data-[state=active]:hover:bg-white cursor-pointer"
                            >
                                <FileSignature className="w-4 h-4 text-muted-foreground group-data-[state=active]:text-primary group-hover:scale-110 transition-transform duration-300" />
                                <span>Letter</span>
                            </TabsTrigger>
                        </TabsList>

                        <TabsContent value="policy" className="mt-0 focus-visible:outline-none">
                            <NestedTabs category="policy" />
                        </TabsContent>

                        <TabsContent value="terms" className="mt-0 focus-visible:outline-none">
                            <NestedTabs category="terms" />
                        </TabsContent>

                        <TabsContent value="letter" className="mt-0 focus-visible:outline-none">
                            <NestedTabs category="letter" />
                        </TabsContent>
                    </Tabs>
                </div>
            </div>
        </Layout>
    )
}

export default Setting